import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export function useAction() {
    const navigate = useNavigate();
    const [step, setStep] = useState(1);

    const handleCancel = () => {
        navigate('/active-group/list')  
    }

    const handleNextStep = () => {
        setStep(step + 1);
    }

    const handleBackStep = () => {
        setStep(step - 1);
    }

    const handleGoToStep = (step) => {
        setStep(step);
    }

    return {
        step,
        handleCancel,
        handleNextStep,
        handleBackStep,
        handleGoToStep
    }
}